import { useSession } from '../auth/SessionProvider.js';
import { GuideDocument } from '../help/GuideDocument.js';
import { USPS_STEP_GUIDE } from '../help/uspsStepGuide.js';
import { VGS_STEP_GUIDE } from '../help/vgsStepGuide.js';

/**
 * The step-by-step guide for whichever side the reader is on. The VGS one describes
 * administration and pricing, so it is selected by organization type rather than being
 * a document a customer account could reach.
 */
export function StepGuidePage() {
  const { isContractor } = useSession();

  return isContractor ? (
    <GuideDocument guide={VGS_STEP_GUIDE} fileName="VGS-Step-by-Step-Guide.docx" />
  ) : (
    <GuideDocument guide={USPS_STEP_GUIDE} fileName="USPS-Step-by-Step-Guide.docx" />
  );
}
